import routes from './../routes'
import vue from 'vue'
import {filterResponse, filterErrors} from './../client'

export const getRecent = (clientId, limit) => {
    return vue.http.get(routes.payment.recent + `clientId=${clientId}` + (limit ? `&limit=${limit}` : '')).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getHistory = (clientId) => {
    return vue.http.get(routes.payment.history + `clientId=${clientId}`).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getRecurring = (nextDate) => {
    return vue.http.get(routes.payment.recurring + `nextDate=${nextDate}`).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
